import { Button } from '@prisjakt/ui/button';
import { ButtonSize } from '@prisjakt/ui/button/variants';
import { BodyMediumText, BodySmallText } from '@prisjakt/ui/text/variants';
import { colors, layout } from 'src/components/base';
import HorizontalScroll from 'src/components/horizontal-scroll';
import styled, { css } from 'styled-components';
import { List } from 'src/components/horizontal-scroll/styles';

const getRightFontColor = (color: string) =>
  color.endsWith('Base900')
    ? colors.lightTheme.base900
    : colors.lightTheme.base0;

export const MainTitle = styled.div`
  margin: ${layout.measurements.spacing050};
`;
export const ColumnContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const columnCSS = (props: {
  bgColor: string | null;
  bgImageUrl: string | null;
  isImageOfProduct: boolean | null;
  numberOfColumns: number;
}) => {
  const bg = props.bgImageUrl ? `url('${props.bgImageUrl}')` : props.bgColor;
  return css`
    width: ${props.isImageOfProduct || props.numberOfColumns > 4
      ? '234px'
      : `${100 / props.numberOfColumns}%`};
    min-width: ${props.isImageOfProduct || props.numberOfColumns > 4
      ? '234px'
      : `${100 / props.numberOfColumns}%`};
    margin: ${layout.measurements.spacing050};
    padding: ${layout.measurements.spacing100};
    background: ${bg};
    background-size: cover;
    background-position-x: 50%;
    border-radius: ${layout.measurements.spacing050};
    display: flex;
    flex-direction: column;
    justify-content: ${props.isImageOfProduct ? 'flex-end' : 'space-between'};
    ${props.isImageOfProduct ? 'text-align: center;' : null};
  `;
};

export const Column = styled.div(columnCSS);

export const ColumnAsLink = styled.a(columnCSS);

// Agreed upon size for the product in the background image.
export const CenteredTransparentBoxForProductImage = styled.div`
  height: 220px;
`;
export const CenteredSmallTitle = styled(BodySmallText)`
  max-height: 20px;
`;

export const CenteredText = styled(BodyMediumText)`
  text-align: center;
  max-height: 50px;
`;

export const ColumnTitleAndText = styled.div<{ color: string }>`
  color: ${p => getRightFontColor(p.color)};
`;

export const ColumnButton = styled(Button).attrs({
  fullWidth: true,
  size: ButtonSize.NORMAL,
})<{ color: string }>`
  color: ${p => getRightFontColor(p.color)} !important;
  margin: 0 auto;
  width: 100%;
  text-align: center;
  padding: ${layout.measurements.spacing050} !important;
`;

export const ColumnHorizontalScroll = styled(HorizontalScroll)`
  li > * {
    width: 234px;
    height: 100%;
  }
  ${List} {
    li {
      margin-left: 0;
    }
  }
`;
